<template>
  <div>
    <label
      class="ts-uppercase ts-font-semibold ts-bg-blue-600 ts-text-white ts-px-1 ts-pt-1 ts-rounded-sm required"
    >{{$t('user.branch')}}</label>
    <ts-loading-banner :loading="loading">
      <ul id="branch-group">
        <li v-for="(branch, index) in branches" :key="index">
          <div class="ts-flex ts-items-center ts-justify-between">
            <ts-checkbox
              @change="setBranches"
              :value="`${branch.branch_id}`"
              :checkedValue="Object.keys(model.branches)"
            ><span class="ts-text-blue-500 ts-font-normal ts-text-sm">{{ branch.branch_name_en }}</span></ts-checkbox>
            <div
              class="custom-control custom-switch"
              v-tooltip="'default'"
              v-if="Object.keys(model.branches).includes(`${branch.branch_id}`)"
            >
              <input
								v-model="model.branches[branch.branch_id].is_default"
								@input="(event) => setAsDefaultBranch(branch.branch_id, event)" 
								type="checkbox" 
								class="custom-control-input" 
								:id="`customSwitchBranch-${branch.branch_id}`" 
							/>
              <label class="custom-control-label" :for="`customSwitchBranch-${branch.branch_id}`"></label>
            </div>
          </div>
          <ul class="ts-border-l ts-w-full"
						v-if="Object.keys(model.branches).includes(`${branch.branch_id}`)"
					>
            <li class="ts-ml-8" v-for="(warehourse, index) in branch.warehourses" :key="index">
              <div class="ts-flex ts-items-center ts-space-x-4">
                <ts-checkbox
									@change="setWarehourse(warehourse)"
									:checkedValue="Object.keys(model.branches[warehourse.branch_id].warehourse)"
									:value="`${warehourse.location_id}`"
								>
										<span class="ts-text-gray-700 ts-text-xs ts-font-light">{{ warehourse.location_name_en }}</span>
                    <span v-if="warehourse.is_main_warehouse"
                      class="ts-ml-2 ts-font-semibold ts-text-red-600 ts-font-marck-script ts-tracking-wider"
                    >(main warehouse)</span>
								</ts-checkbox>
                <div 
									class="custom-control custom-switch ts-mt-2" 
									v-tooltip="'default'"
									v-if="Object.keys(model.branches[warehourse.branch_id].warehourse).includes(`${warehourse.location_id}`)"
								>
                  <input
										v-model="model.branches[warehourse.branch_id].warehourse[warehourse.location_id].is_default" 
										type="checkbox" 
										class="custom-control-input" 
										:id="`customSwitchBranch-w-${warehourse.location_id}`"
										@input="(event) => setAsDefaultWarehourse(warehourse, event)" 
									/>	
                  <label class="custom-control-label" :for="`customSwitchBranch-w-${warehourse.location_id}`"></label>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
      <div class="validate" v-if="errors.has('branches')">{{ errors.first('branches') }}</div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { transform } from 'lodash'

export default {
  name: 'branchList',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {}
    }
  },
  computed: {
    branches() {
      return this.$store.state.security.user.branches;
    }
  },
  created() {
    this.model = this.value
    this.fetchBranch()
  },
  methods: {
    fetchBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/branch')
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranches(branches) {
			this.model.branches = transform(
        branches,
        (result, branchId) => {
          result[branchId] = {
						warehourse: this.model.branches[branchId]
							? this.model.branches[branchId].warehourse 
							: {},
            is_default: this.model.branches[branchId]
              ? this.model.branches[branchId].is_default
              : false
          }
        },
        {}
			)
		},
		setWarehourse(warehourse){
			if(this.model.branches[warehourse.branch_id].warehourse.hasOwnProperty(warehourse.location_id)){
				delete this.model.branches[warehourse.branch_id].warehourse[warehourse.location_id]
			}else{
				let location = Object.assign({}, [warehourse.location_id])
				let newValue = transform(location, (result, locationId) => {
						result[locationId] = {
							is_default: this.model.branches[warehourse.branch_id].warehourse[locationId] 
								? this.model.branches[warehourse.branch_id].warehourse[locationId].is_default
								: false
						}
				},{})

				this.model.branches[warehourse.branch_id].warehourse = Object.assign(this.model.branches[warehourse.branch_id].warehourse, newValue)
			}
			this.$forceUpdate() 
		},
		setAsDefaultBranch(branchId, event) {
      Object.keys(this.model.branches)
        .filter((bKey) => bKey != branchId)
        .forEach((bKey) => {
          this.$set(this.model.branches[bKey], 'is_default', false)
        })

      this.$set(this.model.branches[branchId],'is_default', event.target.checked)
      this.$forceUpdate()
		},
		setAsDefaultWarehourse(obj, event){
			Object.keys(this.model.branches[obj.branch_id].warehourse)
				.filter((lkey) => lkey != obj.location_id)
				.forEach((lkey) => {
					this.$set(this.model.branches[obj.branch_id].warehourse[lkey], 'is_default', false)
				})

				this.$set(this.model.branches[obj.branch_id].warehourse[obj.location_id], 'is_default', event.target.checked)
				this.$forceUpdate()
		}
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style lang="css" scoped>
#branch-group {
  max-height: 360px;
  overflow-y: scroll;
}
</style>